import { FC, PropsWithChildren, ReactElement } from 'react'
import classnames from 'classnames'

import Icon from '../../../../../components/style/Icon/Icon'
import { formatDate, getSameDay } from '../../../../../helpers/date'
import { translate } from '../../../../../helpers/translations/translator'
import { SpecialDayViewModel } from '../../../../../models'
import ElementWithTooltip from '../../../../compositions/ElementWithTooltip/ElementWithTooltip'

import './UserCalendarDayContent.scss'

interface UserCalendarDayContentProps extends PropsWithChildren {
    day: Date;
    specialDays: SpecialDayViewModel[];
    showHeader: boolean;
    className?: string;
}

const UserCalendarDayContent: FC<UserCalendarDayContentProps> = ({
    day,
    children,
    specialDays = [],
    showHeader = true,
    className = '',
}): ReactElement => {
    const sameDay = getSameDay(day)

    const dayContentClassName = classnames('user-calendar-day-content', {
        'user-calendar-day-content--today': sameDay,
    }, className)

    const dayContentHeaderClassName = classnames('user-calendar-day-content__header', {
        'user-calendar-day-content__header--today': sameDay,
    }, className)

    const dayContentHeaderDayClassName = classnames('user-calendar-day-content__header-day', {
        'user-calendar-day-content__header-day--today': sameDay,
    }, className)

    return (
        <div className={dayContentClassName}>
            {showHeader && (
                <div className={dayContentHeaderClassName}>
                    <span className="user-calendar-day-content__header-label">
                        { sameDay && translate('common.today') }
                    </span>

                    <span className={dayContentHeaderDayClassName}>
                        {formatDate(new Date(day), 'd')}
                    </span>

                    {specialDays.length > 0 && (
                        <div className="user-calendar-day-content__header-special-days">
                            {specialDays.map((specialDay) => (
                                <ElementWithTooltip
                                    key={specialDay.id}
                                    tooltipIsActive
                                    tooltipText={specialDay.description}
                                    className="user-calendar-day-content__header-special-day-tooltip"
                                >
                                    <Icon
                                        kind={specialDay.type}
                                        fontSize={14}
                                        className="user-calendar-day-content__header-special-day-icon"
                                    />
                                </ElementWithTooltip>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {children}
        </div>
    )
}

export default UserCalendarDayContent
